import { Component, HostListener, OnInit } from '@angular/core';
import * as Aos from 'aos';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

  isScrolled: boolean = false;

  constructor() { }

  ngOnInit(): void {
    Aos.init();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 0;
  }
}
